import React from 'react'

const clientesRoutes = [

    {
        path: '/logs/auditoria',
        exact: true,
        component: React.lazy(() => import('./LogsIndex')),
    },
    {
        path: '/logs/acesso',
        exact: true,
        component: React.lazy(() => import('./LogsAcesso')),
    },

]

export default clientesRoutes
